export enum ELoaderType {
  /** regular animation */
  default,
  /** book loading animation */
  book,
}
